import '@/assets/fonts/lynny/style.css'
import '@/assets/fonts/socialMedia/style.css'
import '@/assets/sass/global.sass'
import 'aos/dist/aos.css'
import '@/assets/fonts/Gilroy/Gilroy.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import property from './property'
import './plugins/element.js'
import AOS from 'aos'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueCountdown from '@chenfengyuan/vue-countdown'

Vue.component(VueCountdown.name, VueCountdown)

Vue.config.productionTip = false
Vue.use(VueReCaptcha, {siteKey: '6LdIPdIUAAAAAB35w0qXu3cGnufkNAGPLWmJbiDE', loaderOptions: {
  useRecaptchaNet: true
}})

new Vue({
  data: property.data,
  computed: property.computed,
  methods: property.methods,
  router,
  store,
  created () {
    AOS.init()
  },
  render: h => h(App)
}).$mount('#app')
